import React from 'react';
import {Link} from "react-router-dom";
const styles = {
    ButtonCheckoutStyle: {
        width: "100%",
        backgroundColor: "#222",
        padding: "10px",
        textAlign: "center",
        color: "#FFF",
        border: "0",
        textTransform: "uppercase",
        cursor: "pointer",
        borderRight: "1px solid #FFF"
    },
    container : {
        width: "100%"
    }
}
export default function ButtonCart({ children, url, toggleIsVisible }) {
    return (
        <div style={styles.container}>
            <Link onClick={() => toggleIsVisible() } to={url}><button style = {styles.ButtonCheckoutStyle}>{children}</button></Link>
        </div>
    )
}
